import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/app-icon-1024.png';
import StoreBadges from '../StoreBadges/StoreBadges';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const handleLogoClick = () => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="logo" onClick={handleLogoClick}>
          <img src={logo} alt="LunarLog AI" className="logo-image" />
          <span className="logo-text">LunarLog AI</span>
        </div>
        
        <nav className={`nav-links ${isMobileMenuOpen ? 'mobile-active' : ''}`}>
          <Link to="/features" className={isActive('/features') ? 'active' : ''}>Features</Link>
          <Link to="/howitworks" className={isActive('/howitworks') ? 'active' : ''}>How It Works</Link>
          <Link to="/blog" className={isActive('/blog') ? 'active' : ''}>Blog</Link>
          <Link to="/faq" className={isActive('/faq') ? 'active' : ''}>FAQ</Link>
          <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>Contact</Link>
        </nav>
        
        <div className="nav-cta">
          <StoreBadges compact />
        </div>
        
        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle mobile menu"
        >
          <i className={isMobileMenuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </button>
      </div>
    </header>
  );
};

export default Header;
